"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getServiceUri = exports.GraphQLServices = void 0;
var url_parse_1 = __importDefault(require("url-parse"));
var GraphQLServices;
(function (GraphQLServices) {
    GraphQLServices["Notification"] = "notification";
    GraphQLServices["RambodyPackages"] = "rambody-package";
    GraphQLServices["Trainer"] = "trainer";
    GraphQLServices["Trainee"] = "trainee";
    GraphQLServices["Exercise"] = "exercise";
    GraphQLServices["User"] = "user";
    GraphQLServices["Chat"] = "chat";
    GraphQLServices["ConfigProvider"] = "config-provider";
    GraphQLServices["Credit"] = "credit";
})(GraphQLServices = exports.GraphQLServices || (exports.GraphQLServices = {}));
/**
 * Returns the uri according to each service
 * @param service GraphQL service
 */
var getServiceUri = function (baseUrl, service) {
    var url = new url_parse_1.default(baseUrl);
    url.set("pathname", "" + url.pathname + service);
    return url.toString();
};
exports.getServiceUri = getServiceUri;
//# sourceMappingURL=services.js.map